import { LOCALE_ID, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import {
  NbActionsModule,
  NbLayoutModule,
  NbMenuModule,
  NbSearchModule,
  NbSidebarModule,
  NbUserModule,
  NbContextMenuModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbThemeModule,
  NbCalendarRangeModule,
  NbCalendarModule,
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbSecurityModule } from '@nebular/security';

import {
  FooterComponent,
  HeaderComponent,
  SearchInputComponent,
  TinyMCEComponent,
} from './components';
import {
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
} from './pipes';
import {
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
} from './layouts';
import { DEFAULT_THEME } from './styles/theme.default';
import { COSMIC_THEME } from './styles/theme.cosmic';
import { CORPORATE_THEME } from './styles/theme.corporate';
import { DARK_THEME } from './styles/theme.dark';

//
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HeaderFormComponent } from './components/header/form.header.component';
import { HeaderDialogContactComponent } from './components/header/dialog-contact.component';
import { FooterMenuComponent } from './components/footer-menu/footer-menu.component';

import { PlaceholderImagePipe } from './pipes/placeholder-image.pipe';
import { ReminderAppComponent } from './components/reminder-app/reminder-app.component';
import { RouterModule } from '@angular/router';
import localePt from '@angular/common/locales/pt';
import { TranslateService } from '@ngx-translate/core';
import { GeneralService } from '../@core/data/general.service';

registerLocaleData(localePt);

const NB_MODULES = [
  NbLayoutModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbContextMenuModule,
  NbSecurityModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbEvaIconsModule,
  FormsModule,
  ReactiveFormsModule,
  CommonModule,
  RouterModule,
  NbCalendarModule,
  NbCalendarRangeModule
];
const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  SearchInputComponent,
  TinyMCEComponent,
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
  HeaderFormComponent,
  HeaderDialogContactComponent,
  ReminderAppComponent,
  FooterMenuComponent
];
const ENTRY_COMPONENTS = [
  HeaderFormComponent,
  HeaderDialogContactComponent,
];
const PIPES = [
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
  PlaceholderImagePipe
];

@NgModule({
  imports: [...NB_MODULES],
  exports: [...PIPES, ...COMPONENTS],
  declarations: [...COMPONENTS, ...PIPES, ...ENTRY_COMPONENTS]
})

export class ThemeModule {
  constructor(private generalService: GeneralService) {}

  public getBrowserLang(): string {
    return this.generalService.getBrowserLang();
  }

  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        ...NbThemeModule.forRoot(
          {
            name: 'corporate',
          },
          [ DEFAULT_THEME, COSMIC_THEME, CORPORATE_THEME, DARK_THEME ],
        ).providers,
        { provide: LOCALE_ID, useFactory: (translateService: TranslateService) => translateService.getBrowserLang(), deps: [TranslateService] }
      ],
    };
  }
}
